import { CountUp } from 'countup.js';

if ($('#targetId')[0]) {
  const targetElement = document.getElementById('targetId');
  let currentValue = 127;
  const targetValue = 999;

  function nonLinearCount() {
    const intervals = [
      { range: 138, duration: 100 },
      { range: 141, duration: 1000 },
      { range: 150, duration: 200 },
      { range: 162, duration: 100 },
      { range: 168, duration: 1000 },
      { range: 189, duration: 50 },
      { range: 192, duration: 400 },
      { range: 209, duration: 20 },
      { range: 213, duration: 1000 },
      { range: 221, duration: 200 },
      { range: 232, duration: 100 },
      { range: 235, duration: 1000 },
      { range: 244, duration: 200 },
      { range: 256, duration: 100 },
      { range: 262, duration: 1000 },
      { range: 283, duration: 50 },
      { range: 286, duration: 400 },
      { range: 303, duration: 20 },
      { range: 307, duration: 1000 },
      { range: 315, duration: 200 },
      { range: 326, duration: 100 },
      { range: 329, duration: 1000 },
      { range: 338, duration: 200 },
      { range: 350, duration: 100 },
      { range: 356, duration: 1000 },
      { range: 377, duration: 50 },
      { range: 380, duration: 400 },
      { range: 397, duration: 20 },
      { range: 401, duration: 1000 },
      { range: 409, duration: 200 },
      { range: 420, duration: 100 },
      { range: 423, duration: 1000 },
      { range: 432, duration: 200 },
      { range: 444, duration: 100 },
      { range: 450, duration: 1000 },
      { range: 471, duration: 50 },
      { range: 474, duration: 400 },
      { range: 491, duration: 20 },
      { range: 495, duration: 1000 },
      { range: 503, duration: 200 },
      { range: 514, duration: 100 },
      { range: 517, duration: 1000 },
      { range: 526, duration: 200 },
      { range: 538, duration: 100 },
      { range: 544, duration: 1000 },
      { range: 565, duration: 50 },
      { range: 568, duration: 400 },
      { range: 585, duration: 20 },
      { range: 589, duration: 1000 },
      { range: 597, duration: 200 },
      { range: 608, duration: 100 },
      { range: 611, duration: 1000 },
      { range: 620, duration: 200 },
      { range: 632, duration: 100 },
      { range: 638, duration: 1000 },
      { range: 659, duration: 50 },
      { range: 662, duration: 400 },
      { range: 679, duration: 20 },
      { range: 683, duration: 1000 },
      { range: 691, duration: 200 },
      { range: 702, duration: 100 },
      { range: 705, duration: 1000 },
      { range: 714, duration: 200 },
      { range: 726, duration: 100 },
      { range: 732, duration: 1000 },
      { range: 753, duration: 50 },
      { range: 756, duration: 400 },
      { range: 773, duration: 20 },
      { range: 777, duration: 1000 },
      { range: 785, duration: 200 },
      { range: 796, duration: 100 },
      { range: 799, duration: 1000 },
      { range: 820, duration: 50 },
      { range: 823, duration: 400 },
      { range: 840, duration: 20 },
      { range: 844, duration: 1000 },
      { range: 852, duration: 200 },
      { range: 863, duration: 100 },
      { range: 866, duration: 1000 },
      { range: 875, duration: 200 },
      { range: 887, duration: 100 },
      { range: 893, duration: 1000 },
      { range: 914, duration: 50 },
      { range: 917, duration: 400 },
      { range: 934, duration: 20 },
      { range: 938, duration: 1000 },
      { range: 946, duration: 200 },
      { range: 957, duration: 100 },
      { range: 960, duration: 1000 },
      { range: 969, duration: 200 },
      { range: 981, duration: 100 },
      { range: 999, duration: 1000 },
      // { range: 999, duration: 2000 } // Adjust the final range and duration
    ];

    const currentInterval = intervals.find(interval => currentValue < interval.range);

    if (currentInterval) {
      currentValue++;
      targetElement.textContent = currentValue;
      setTimeout(nonLinearCount, currentInterval.duration);
    }
  }

  nonLinearCount();
}
